// A cost in US dollars as it is shown: "$0.0077" for a small one (a resume costs well under a cent or two, so four decimals say something) and
// "$0.32" once it is a few cents or more. null (no known price) gives null, so callers can leave the cost out.
export function formatCost(dollars) {
  if (dollars === null || dollars === undefined || Number.isNaN(Number(dollars))) return null

  const amount = Number(dollars)
  if (amount === 0) return '$0.00'
  if (amount < 0.01) return `$${amount.toFixed(4)}`
  if (amount < 1) return `$${amount.toFixed(3)}`
  return `$${amount.toFixed(2)}`
}

// What an AI resume uses, as measured on a real run (gpt-5-mini: 3,359 tokens in, 3,433 out, reasoning included). It is what the model
// prices on the AI settings are turned into a cost for, so the models can be compared on one thing people recognise: a resume.
export const TYPICAL_RESUME = { input: 3400, output: 3400 }

// A price per million tokens: "$0.25", "$0.025", "$10.00". null (no known price) gives null.
export function formatPrice(dollars) {
  if (dollars === null || dollars === undefined || Number.isNaN(Number(dollars))) return null

  return `$${Number(dollars).toFixed(3).replace(/0$/, '')}`
}

// What a typical resume costs with these prices ({ input, cached_input, output } in dollars per million tokens), or null without prices.
export function typicalResumeCost(pricing) {
  if (!pricing) return null

  return (TYPICAL_RESUME.input * pricing.input + TYPICAL_RESUME.output * pricing.output) / 1_000_000
}
